import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Typography,
  Paper,
  useTheme,
  Box,
  useMediaQuery,
} from "@mui/material";
import "./ForgetPassword.css";
import logo from "../../../../assets/logo.png";
import backIcon from "../../../../assets/backIcon.png";
import ToastService from "@/service/toaster.service";
import customerAuthService from "@/service/auth.service/customer.auth.service";

function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedEmail = email.trim();

    setError("");

    if (!trimmedEmail) {
      setError("Email is required");
      return;
    }

    if (!validateEmail(trimmedEmail)) {
      setError("Enter a valid email address");
      return;
    }

    setLoading(true);

    try {
      const data = await customerAuthService.forgotPassword(trimmedEmail.toLowerCase());

      if (data.status === true) {
        ToastService.success("Verification code sent successfully to your email!");

        setTimeout(() => {
          navigate("/customer/auth/verify-reset-password-otp", {
            state: { email: trimmedEmail },
          });
        }, 2000);
      }
    } catch (err) {
      console.error("Forgot Password Error:", err);

      const message =
        err?.response?.data?.data?.error ||
        err?.response?.data?.message ||
        "Failed to send verification code!";

      ToastService.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection={isMobile ? "column" : "row"} height="100vh">
      <Box
        flex={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: "#f5f5f5",
          p: isMobile ? 4 : isTablet ? 6 : 0,
          height: isMobile ? "70vh" : "100vh",
        }}
      >
        <Link to="/customer/auth/login" className="back-button">
          <img src={backIcon} alt="Back" />
        </Link>

        <Paper className="inner-card" elevation={5} sx={{ p: 4, width: isMobile ? '100%' : 400 }}>
          <Typography variant="h5" color="#5E5ACF" fontWeight="bold" gutterBottom>
            Forget Password?
          </Typography>
          <Typography variant="body2" mb={2}>
            Please enter your email so we can send you a verification code.
          </Typography>

          <form onSubmit={handleSubmit} noValidate>
            <TextField
              fullWidth
              margin="normal"
              label="Email Address"
              variant="outlined"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              error={Boolean(error)}
              helperText={error}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              className="btn-submit"
              sx={{
                mt: 2,
                color: "black",
                fontWeight: "bold",
                backgroundColor: "#FFD700",
                '&:hover': { backgroundColor: "#FFC107" },
              }}
              disabled={loading}
            >
              {loading ? "Sending..." : "Submit"}
            </Button>
          </form>
        </Paper>
      </Box>
    </Box>
  );
}

export default ForgetPassword;
